import React, { useEffect, useState } from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

import {
    Portlet,
    PortletBody,
    PortletHeader
} from "../../../partials/content/Portlet";
import { productivityServices } from "./Productivity.services";

import "./ProductivityTracker.css";
import { useSelector } from "react-redux";

export default function PmPerformanceTracker() {
    const [selectedPm, setSelectedPm] = useState("");

    const [pmList, setPmList] = useState([]);
    const [options, setOptions] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState("");
    const [selectedYear, setSelectedYear] = useState("");

    const [scoreData, setScoreData] = useState(null);
    const [noDataMessage, setNoDataMessage] = useState(null);
    const [isFetching, setIsFetching] = useState(false);

    const userDetails = useSelector(
        state => state.auth?.user
    );

    const getPmList = async (cityId) => {
        try {
            const data = { cityId };

            const result = await productivityServices.getPmList(data);

            if (result && result.data) {
                const pMs = result.data.map((pm) => ({
                    value: pm.id,
                    label: pm.fullName
                }));

                setPmList(pMs);
            }
        } catch (error) {
            console.log("Error fetching PM list", error);
        }
    };

    const getProductivityScore = async () => {

        if (!selectedPm || !selectedMonth?.month || !selectedMonth?.year) {
            setScoreData(null);
            setNoDataMessage("Please select Month and PM from filters");
            return;
        }

        setIsFetching(true);
        setNoDataMessage(null);

        try {
            const payload = {
                month: selectedMonth.month,
                year: selectedMonth.year,
                pm_id: Number(selectedPm)
            };

            const result = await productivityServices.getMyScore(payload);

            console.log("Productivity Score Data >>>>>>>>>", result);

            if (result && result.status === 200) {

                if (result.data && result.data.message) {
                    setScoreData(null);
                    setNoDataMessage(result.data.message);
                } else {
                    setScoreData(result.data);
                    setNoDataMessage(null);
                }
            } else {
                setScoreData(null);
                setNoDataMessage("Unable to fetch performance score.");
            }

        } catch (error) {
            console.log("Error fetching productivity score", error);

            setScoreData(null);
            setNoDataMessage("Unable to fetch performance score.");
        } finally {
            setIsFetching(false);
        }
    };

    useEffect(() => {
        if (userDetails?.cityId) {
            getPmList(userDetails.cityId);
        }

        generateMonthYearOptions();
    }, [userDetails?.cityId]);

    useEffect(() => {
        getProductivityScore();
    }, [selectedPm, selectedMonth]);

    const generateMonthYearOptions = () => {
        const newOptions = [];
        const today = new Date();

        for (let i = 0; i < 12; i++) {
            const d = new Date(
                today.getFullYear(),
                today.getMonth() - i,
                1
            );

            const month = d.getMonth() + 1;
            const year = d.getFullYear();

            const label = d.toLocaleString("default", {
                month: "long",
                year: "numeric"
            });

            newOptions.push({
                month,
                year,
                label
            });
        }

        setOptions(newOptions);
    };

    const formatLabel = (key) => {
        return key
            .replace(/([A-Z])/g, " $1")
            .replace(/^./, (str) => str.toUpperCase());
    };

    const renderScoreCard = (title, data, breakdown) => {
        if (!data) return null;

        const percentage =
            data.max > 0
                ? ((data.score / data.max) * 100).toFixed(0)
                : 0;

        return (
            <div className="metric-card">


                <div className="metric-header">
                    <span className="metric-title">
                        {title}
                    </span>

                    <span className="metric-score">
                        {Number(data.score).toFixed(2)}/{data.max}
                    </span>
                </div>


                <div className="progress">
                    <div
                        className="progress-bar"
                        style={{
                            width: `${percentage}%`
                        }}
                    />
                </div>

                <div className="metric-percent">
                    {percentage}% achieved
                </div>

                {breakdown && (
                    <div className="metric-breakdown">

                        {Object.keys(breakdown).map(
                            (key, index) => {

                                const item = breakdown[key];


                                if (
                                    typeof item === "object" &&
                                    item !== null &&
                                    item.score !== undefined
                                ) {
                                    return (
                                        <div
                                            key={index}
                                            className="breakdown-row"
                                        >
                                            <span>
                                                {formatLabel(key)}
                                            </span>

                                            <span>
                                                {item.score}/{item.max}
                                            </span>
                                        </div>
                                    );
                                }

                                return (
                                    <div
                                        key={index}
                                        className="breakdown-row"
                                    >
                                        <span>
                                            {formatLabel(key)}
                                        </span>

                                        <span>
                                            {item}
                                        </span>
                                    </div>
                                );
                            }
                        )}

                    </div>
                )}
            </div>
        );
    };

    const getActiveBand = (score) => {
        if (score >= 80) return "band1";
        if (score >= 70) return "band2";
        if (score >= 61) return "band3";

        return "band4";
    };

    const selectedPmDetails = pmList.find(
        pm => Number(pm.value) === Number(selectedPm)
    );

    const activeBand =
        scoreData &&
        getActiveBand(scoreData.totalScore);

    return (
        <Container fluid className="productivity-container">

            <Portlet fluidHeight>

                <PortletHeader
                    title="Property Manager Performance"
                    toolbar={
                        <div className="leaderboard-toolbar">

                            <div className="toolbar-item">
                                <select
                                    className="form-control productivity-month-select"
                                    value={
                                        selectedMonth
                                            ? `${selectedMonth.month}-${selectedMonth.year}`
                                            : ""
                                    }
                                    onChange={(e) => {

                                        const [
                                            month,
                                            year
                                        ] =
                                            e.target.value.split("-");

                                        setSelectedMonth({
                                            month: Number(month),
                                            year: Number(year)
                                        });
                                    }}
                                >
                                    <option value="">
                                        Select Month
                                    </option>

                                    {options.map((option) => (
                                        <option
                                            key={`${option.month}-${option.year}`}
                                            value={`${option.month}-${option.year}`}
                                        >
                                            {option.label}
                                        </option>
                                    ))}
                                </select>
                            </div>

                            <div className="toolbar-item">

                                <select
                                    disabled={
                                        selectedMonth?.month
                                            ? false
                                            : true
                                    }
                                    className="form-control productivity-month-select"
                                    value={selectedPm}
                                    onChange={(e) =>
                                        setSelectedPm(
                                            e.target.value
                                        )
                                    }
                                >
                                    <option value="">
                                        Select PM
                                    </option>

                                    {pmList.map(pm => (
                                        <option
                                            key={pm.value}
                                            value={pm.value}
                                        >
                                            {pm.label}
                                        </option>
                                    ))}
                                </select>

                            </div>

                        </div>
                    }
                />

                <PortletBody>

                    {isFetching && (
                        <p>Loading...</p>
                    )}

                    {!isFetching &&
                        noDataMessage && (
                            <div className="no-data-box">

                                <h5>
                                    {noDataMessage}
                                </h5>

                                <p className="text-muted">
                                    Scorecard will be available once
                                    performance metrics are generated.
                                </p>

                            </div>
                        )}


                    {!isFetching && scoreData && (

                        <div className="productivity-wrapper">


                            <Row className="mb-4">

                                <Col md={3}>
                                    <Card className="top-card">
                                        <Card.Body>

                                            <h4>
                                                {selectedPmDetails?.label ||
                                                    "Property Manager"}
                                            </h4>

                                            <p className="text-muted mb-0">
                                                {scoreData?.propertiesCount ||
                                                    0}{" "}
                                                Properties
                                            </p>

                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col md={3}>
                                    <Card className="top-card">
                                        <Card.Body>

                                            <h3>
                                                {scoreData.totalScore}/100
                                            </h3>

                                            <p className="text-muted mb-0">
                                                Monthly Score
                                            </p>

                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col md={3}>
                                    <Card className="top-card">
                                        <Card.Body>

                                            <h5 className="text-warning">
                                                {
                                                    scoreData.payoutPercentage
                                                }%
                                                Payout
                                            </h5>

                                            <p className="text-muted mb-0">
                                                Payout Eligibility
                                            </p>

                                        </Card.Body>
                                    </Card>
                                </Col>

                                <Col md={3}>
                                    <Card className="top-card">
                                        <Card.Body>

                                            {scoreData.vsLastMonth ? (
                                                <>
                                                    <h5
                                                        className={
                                                            scoreData.vsLastMonth >=
                                                                0
                                                                ? "text-success"
                                                                : "text-danger"
                                                        }
                                                    >

                                                        {scoreData.vsLastMonth >=
                                                            0
                                                            ? "▲"
                                                            : "▼"}{" "}

                                                        {Math.abs(
                                                            scoreData.vsLastMonth
                                                        )}{" "}
                                                        pts

                                                    </h5>

                                                    <p className="text-muted mb-0">
                                                        Vs Last Month
                                                    </p>
                                                </>
                                            ) : (
                                                <>
                                                    <h6 className="text-muted">
                                                        Soon Available
                                                    </h6>

                                                    <p className="text-muted mb-0">
                                                        Vs Last Month
                                                    </p>
                                                </>
                                            )}

                                        </Card.Body>
                                    </Card>
                                </Col>

                            </Row>


                            <div className="payout-band mb-4">

                                <div
                                    className={`band-item ${activeBand === "band1"
                                            ? "active"
                                            : ""
                                        }`}
                                >
                                    <div className="band-range">
                                        81+
                                    </div>

                                    <div className="band-value">
                                        100%
                                    </div>
                                </div>


                                <div
                                    className={`band-item ${activeBand === "band2"
                                            ? "active"
                                            : ""
                                        }`}
                                >
                                    <div className="band-range">
                                        71–80
                                    </div>

                                    <div className="band-value">
                                        75%
                                    </div>
                                </div>


                                <div
                                    className={`band-item ${activeBand === "band3"
                                            ? "active"
                                            : ""
                                        }`}
                                >
                                    <div className="band-range">
                                        61–70
                                    </div>

                                    <div className="band-value">
                                        50%
                                    </div>
                                </div>


                                <div
                                    className={`band-item ${activeBand === "band4"
                                            ? "active"
                                            : ""
                                        }`}
                                >
                                    <div className="band-range">
                                        &lt;60
                                    </div>

                                    <div className="band-value">
                                        Nil
                                    </div>
                                </div>

                            </div>



                            <Row>

                                <Col md={6}>

                                    {this /* intentionally same format */}

                                    {renderScoreCard(
                                        "Operations & Execution",
                                        scoreData.operationsExecution,
                                        scoreData.operationsExecution?.breakdown
                                    )}

                                </Col>

                                <Col md={6}>

                                    {renderScoreCard(
                                        "Financial Discipline",
                                        scoreData.financialDiscipline
                                    )}

                                    {scoreData?.financialDiscipline
                                        ?.financialPercentage < 100 && (

                                            <div className="card mt-3 shadow-sm">

                                                <div className="card-header bg-light">
                                                    <h5 className="mb-0 text-primary">
                                                        How to Earn Full Score
                                                    </h5>
                                                </div>

                                                <div className="card-body">

                                                    <p className="card-text">
                                                        Collect rent within 5 days
                                                        of the due date to earn
                                                        the maximum 15 points.
                                                    </p>

                                                    <div className="table-responsive">

                                                        <table className="table table-bordered table-striped text-center mb-0">

                                                            <thead className="table-light">

                                                                <tr>
                                                                    <th scope="col">
                                                                        Delay
                                                                    </th>

                                                                    <th scope="col">
                                                                        Points
                                                                    </th>
                                                                </tr>

                                                            </thead>

                                                            <tbody>

                                                                <tr>
                                                                    <td>
                                                                        0–5 Days
                                                                    </td>

                                                                    <td className="text-success fw-bold">
                                                                        +15
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>
                                                                        6–10 Days
                                                                    </td>

                                                                    <td className="text-primary fw-bold">
                                                                        +10
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>
                                                                        11–15 Days
                                                                    </td>

                                                                    <td className="text-warning fw-bold">
                                                                        +5
                                                                    </td>
                                                                </tr>

                                                                <tr>
                                                                    <td>
                                                                        &gt;15 Days /
                                                                        Not Received
                                                                    </td>

                                                                    <td className="text-danger fw-bold">
                                                                        0
                                                                    </td>
                                                                </tr>

                                                            </tbody>

                                                        </table>

                                                    </div>

                                                </div>

                                            </div>
                                        )}

                                </Col>

                                <Col md={6} className="mt-4">

                                    {renderScoreCard(
                                        "Customer Experience",
                                        scoreData.customerExperience,
                                        scoreData.customerExperience?.breakdown
                                    )}

                                </Col>


                                <Col md={6} className="mt-4">

                                    {renderScoreCard(
                                        "Renewal Performance",
                                        scoreData.renewalPerformance,
                                        scoreData.renewalPerformance?.breakdown
                                    )}

                                </Col>

                            </Row>

                        </div>

                    )}

                </PortletBody>

            </Portlet>

        </Container>
    );
}